<!-- 我的订单item -->
<template>
<div class="">
<div class="item-block">
  <div class="odd-numbers"><p class="num">单号：{{order.order_number}} <span v-if="+order.from_replace_member_id" class="tag">代下单</span>
  <span v-if="+order.is_first" class="tag">首单</span>
  </p><span class="state">{{order.order_state_name}}</span></div>
    <ul class="order-item-goods-across" v-if="order.goods_detail.length>1"
      @click="toDetails(order.order_number)">
      <li
        v-for="(goods,index) in order.goods_detail.slice(0,4)"
        :key="index">
        <img :src="goods.image || $notImg"/>
        <p><span>x{{Math.ceil(+goods.quantity)}}</span></p>
      </li>
      <li class="right-circle-wrap"><cc-svg-icon size="21px" @click="toDetails(order.order_number)" class-name="right-circle" icon-class="right-circle" /></li>
    </ul>
    <ul class="order-item-goods-vertical"
      v-else
      @click="toDetails(order.order_number)">
      <li v-for="(goods,index) in order.goods_detail" :key="index">
        <div class="goods_img">
          <img :src="goods.image || $notImg" alt="">
        </div>
        <div class="goods_info">
          <div>
            <p class="font1">{{goods.general_name}} {{goods.norms}} </p>
            <p class="font2">数量：{{Math.ceil(+goods.quantity)}}</p>
          </div>
            <!-- 积分商品 -->
            <!-- 配送价的积分商品 -->
           <p v-if="order.is_delivery_flag==1">
             <span v-if="goods.type == 6">
                积分：<span class="price" style="font-size:.15rem">配送价</span>
             </span>
             <!-- 不是积分商品的配送价 -->
             <span class="price" v-else v-delivery-price></span>
            </p>
            <!-- 不是配送价的积分商品 -->
              <p v-else-if="goods.type == 6">
             <span>
                积分：<span class="price" style="font-size:.15rem">{{goods.price}}</span>
             </span></p>
             <!-- 既不是配送价也不是积分商品 -->
              <p v-else><span class="bid_price">￥{{goods.price}}</span></p>
        </div>
      </li>
    </ul>
  <div class="amount">
    <span class="amount-goods">共{{order.num}}种商品</span>
     <p class="total" v-if="+order.coupon_price">优惠：
      <span class="price_coupon" >￥{{order.coupon_price}}</span>
      </p>
    <blockquote v-if="(order.payment_method==1 && order.payment_state==0)">
    <p class="total" v-if="+order.order_state==10||+order.order_state==0">需付款：
      <span class="price" style="font-size:.15rem" v-if="+order.is_delivery_flag">配送价</span>
      <span class="price" v-else>￥<span class="money_size">{{order.total_money}}</span></span>
      </p>
       </blockquote>
    <blockquote v-if="order.order_state==3||!(order.payment_method==1 && order.payment_state==0)">
    <p class="total">实付款：
      <span class="price" style="font-size:.15rem" v-if="+order.is_delivery_flag">配送价</span>
      <span class="price" v-else>￥<span class="money_size">{{order.total_money}}</span></span>
      </p>
             </blockquote>
  </div>
    <blockquote v-if="+order.payment_method==1&&+order.payment_state==0">
  <div class="remaining-payment-time" v-if="+order.order_state==0||+order.order_state==10">
       <span>剩余时间</span>
           <div class="inline _time">
                <b v-if="+order.countDown==0">00:00:00</b>
                <b v-else>{{order.countDown.h+':'+order.countDown.m+':'+order.countDown.s}}</b>
            </div>
  </div>
   </blockquote>
  <div class="operation">
       <blockquote v-if="+order.payment_method==1&&+order.payment_state==0">
    <p @click="orderCancel(order.order_number)" v-if="+order.order_state==0||+order.order_state==10">取消订单</p>
     </blockquote>
 <!-- </div> -->
   <!-- <div class="operation" > -->
     <blockquote v-if="+order.order_state===3 || !(order.payment_method==1 && order.payment_state==0)">
    <p class="another-order" @click="buyAgain(order.order_number)">再次购买</p>
    </blockquote>
    <!-- <p class="confirm-order" v-if="+isReplace==1&&+order.order_state==10">确认订单</p> -->
    <p class="confirm-order" v-if="+order.order_state==10&&+isReplace!=1" @click="orderConfirm(order.order_number)">确认订单</p>
  <!-- </blockquote> -->
    <blockquote v-if="+order.payment_method==1&&+order.payment_state==0">
    <p class="payment" v-if="(+isReplace!==1&&+order.order_state==10)||+order.order_state==0" @click="payMoney(order.order_number)">立即支付</p>
    </blockquote>
    <p class="confirm-receipt"
     v-else-if="+order.order_state==1&&+order.logis_state==1"
      @click="orderok(order.order_number)"
    >确认收货</p>
  </div>
</div>
</div>
</template>

<script>

import Vue from 'vue'
import { orderConfirm, orderOk, orderCancel, againBuy } from '~fetch/manage-center/order-management'
import Command from '@/mixins/command'
import { SessionStorage } from '@/utils'
import {
  Toast,
  Dialog
} from 'vant'
Vue.use(Toast)
  .use(Dialog)
export default {
  mixins: [Command],
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    isReplace: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data () {
    return {
      order: this.item
    }
  },

  computed: {
  },

  created () {
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler () {
        this.order = this.item
      }
    }
  },
  methods: {
    /**
    *@description 去详情页
    */
    toDetails (uid) {
      this.$router.push({ path: '/orderer/details', query: { id: uid } })
      // window.location = '/order/single?oid=' + id + '&type=1&goback=2'
    },
    /**
     * @description 确认收货
     */
    orderok (orderId) {
      Dialog.alert({
        message: '是否确认收货？',
        showCancelButton: true
      }).then(async () => {
        let res = await orderOk({
          order_number: orderId
        })
        if (res.status === 0) {
          this.$emit('changeLoad')
        } else {
          Toast(res.info.msg)
        }
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
    },
    /**
     * @description 确认订单
     */
    orderConfirm (orderId) {
      Dialog.alert({
        message: '是否确认订单？',
        showCancelButton: true
      }).then(async () => {
        let res = await orderConfirm({
          type: 1,
          order_number: orderId
        })
        if (res.status === 0) {
          this.$emit('changeLoad')
        } else {
          Toast(res.info.msg)
        }
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
    },
    /**
     * @description 取消订单
     */
    orderCancel (orderid) {
      Dialog.alert({
        message: '是否取消订单',
        confirmButtonText: '确定取消',
        cancelButtonText: '暂不取消',
        showCancelButton: true
      }).then(async () => {
        let res = await orderCancel({
          order_number: orderid
        })
        if (res.status === 0) {
          this.$emit('changeLoad')
        } else {
          Toast(res.info.msg)
        }
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
    },
    /**
     * @description 立即支付
     */
    payMoney (id) {
      window.location = '/order/success/?order_number=' + id
    },
    /**
     * 再次购买
     */
    async buyAgain (orderId) {
      let res = await againBuy({
        order_number: orderId
      })
      if (res.status === 0) {
        Toast(res.info.msg)
        this.cartGetnum()
        SessionStorage.setItem('hasNewGoods', '1')
      } else {
        Toast(res.info.msg)
      }
    }
  }

}

</script>
<style lang='scss' scoped>
 .van-dialog .van-dialog__confirm{
    color: #fff;
    border: 2px solid red;
}

.tag{
  width: 45px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  text-align: center;
  color: #FF5B7AFF;
  border: 1px solid #FB526EFF;
  display:inline-block;
  margin-left: 5px;
  border-radius: 2px;
}
.item-block{
  width: 355px;
  padding: 5px 10px 10px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 10px;
  margin: 10px auto;
  position: relative;
  .remaining-payment-time{
    position: absolute;
    bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #FF5B7AFF;
    span{
      margin-right: 5px;
    }
  }
}
.odd-numbers{
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  font-size: 12px;
  margin: 10px 0 14px;
  .num{
   color: #333333FF;
  }
  .state{
    color: var(--APP_theme_color);
  }
}
.goods-information{
  position: relative;
.goods-title{
  font-size: 14px;
  color: #333333FF;
  >span{
    margin-right: 10px;
  }
}
.quantity{
  font-size: 12px;
  color: #999999FF;
}
.price{
  font-size: 12px;
  color: #333333FF;
  position: absolute;
  bottom: 0;
}
}
.amount{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  font-size: 12px;
  color: #777777FF;
  align-items: center;
  .total{
    margin-left: 15px;
   .price_coupon{
     color: #777777FF;
        }
   span{
     color: #EA2727FF;
     .money_size{
       font-size: 18px;
     }
   }
  }
}
.operation{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
  p{
    width: 65px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 12px;
    background-color: #fff;
    border: 1px solid #DCDCDCFF;
    text-align: center;
    line-height: 24px;
    margin-left: 10px;
    font-size: 12px;
  }
  .payment,.confirm-receipt{
   background-color: var(--APP_theme_color);
   color: #fff;
   border: none;
  }
  .confirm-order{
     background-color: none;
    border: 1px solid var(--APP_theme_color);
    color: var(--APP_theme_color);
  }
  .another-order{
    background-color: none;
    border: 1px solid var(--APP_theme_color);
    color: var(--APP_theme_color);
  }
}
 .order-item-goods-across{
    height: 90px;
    padding: 10px 0px;
    box-sizing: border-box;
    li{
      width: 65px;
      height: 65px;
      float: left;
      position: relative;
      margin-right: 10px;
      border-radius: 4px;
      overflow: hidden;
      img{
        // width: 100%;
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
      p{
        background:#626262FF;
        min-width:23px ;
        height: 12px;
        opacity: 0.6;
        border-radius: 5px 0 0 5px;
        color: #ffffff;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        bottom: 0;
        right: 0;
        span{
          transform : scale(0.88) ;
        }
      }
    }
  }
 .order-item-goods-vertical{
    padding: 10px 0;
    box-sizing: border-box;
    li{
      display: flex;
      justify-content: flex-start;
      .goods_img{
        width: 65px;
        height: 65px;
        box-sizing: border-box;
        border-radius: 4px;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .goods_info{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 10px;
        width: 285px;
        .font1{
          font-size: 14px;
          color: #333333FF;
        }
        .font2{
          font-size: 12px;
          color: #999999FF;
        }
        .price{
          color: #EA2727;
        }
      }
      .bid_price{
        font-size: 12px;
        color: #333333FF;
      }
    }
  }
  .right-circle-wrap{
  width: 30px !important;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 0!important;
 float: right !important;
  border: none!important;
  color: #DCDCDC;

  .right-circle{

   position: relative;
   right: 0;
  }
}
</style>
